import { render, staticRenderFns } from "./newPromptPage.vue?vue&type=template&id=7ee10344&scoped=true"
import script from "./newPromptPage.vue?vue&type=script&lang=js"
export * from "./newPromptPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee10344",
  null
  
)

export default component.exports